import { show, hide } from 'redux-modal'
import { GLOBAL_SEARCH_MODAL } from 'constant'

export const showModal = () => show(GLOBAL_SEARCH_MODAL)

export const hideGlobalSearchModal = () => dispatch =>
  dispatch(hide(GLOBAL_SEARCH_MODAL))
